var map = {
	"./Display": 23,
	"./Display.vue": 23,
	"./DisplaySection": 24,
	"./DisplaySection.vue": 24,
	"./Example": 25,
	"./Example.vue": 25,
	"./PathLine": 14,
	"./PathLine.vue": 14,
	"./boxshadow": 98,
	"./boxshadow.vue": 98,
	"./colours": 99,
	"./colours.vue": 99,
	"./fonts": 100,
	"./fonts.vue": 100,
	"./layers": 101,
	"./layers.vue": 101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1472;


//////////////////
// WEBPACK FOOTER
// ./src/components/vars ^\.\/.*$
// module id = 1472
// module chunks = 1